'use client';

import './polyfills';
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';

import routes from './routes/routes';
import App from './components/App/app';

import './App.scss';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './assets/ag-grid-overrides.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

const queryClient = new QueryClient({
    defaultOptions: {
        mutations: {
            throwOnError: true
        },
        queries: {
            refetchOnMount: false,
            retry: 0,
            staleTime: 10000
        }
    }
});

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
    <QueryClientProvider client={queryClient}>
        <BrowserRouter>
            <Suspense fallback={null}>
                <App routes={routes} />
            </Suspense>
            <ReactQueryDevtools initialIsOpen={false} />
        </BrowserRouter>
    </QueryClientProvider>
);
